import React from 'react';

import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import { useFeatureLoyaltyUi } from 'hooks/use-feature-loyalty-ui';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { useMobileHeaderComponent } from 'state/mobile-header-nav';

import { AppHeaderContainer } from '../app-header-container';
import { Logo } from '../logo';
import { LogoContainer } from '../styled';

import { PrimaryAction } from './primary-action';
import { SecondaryAction } from './secondary-action';
import { StyledTitle } from './styled';

const StandardMobileHeader: React.FC = () => {
  const isHamburgerMenuEnabled = useFlag(LaunchDarklyFlag.ENABLE_HAMBURGER_MENU_ON_MOBILE);
  const [searchParams] = useSearchParams();
  const { location } = useLocationContext();
  const { formatMessage } = useIntl();
  const { featureLoyaltyUi } = useFeatureLoyaltyUi();
  const rewardsDetailsRoute =
    featureLoyaltyUi?.loyaltyCTAButtons?.loyaltyBannerHomepageAuthenticatedButton
      ?.loyaltyBannerHomepageAuthenticatedLink?.locale ||
    formatMessage({ id: 'routes.loyaltyDashboard' });
  const isRewardsDetailsPage = location.pathname.includes(rewardsDetailsRoute);
  const isInlineRewardDetailPage = isRewardsDetailsPage && !!searchParams.get('inline');

  return (
    <AppHeaderContainer data-mediaquery="headerMobile" data-testid="mobile-header">
      <PrimaryAction isHamburgerMenuEnabled={isHamburgerMenuEnabled} />
      {isInlineRewardDetailPage ? (
        <LogoContainer>
          <StyledTitle>Reward Detail</StyledTitle>
        </LogoContainer>
      ) : (
        <>
          <Logo />
          <SecondaryAction isHamburgerMenuEnabled={isHamburgerMenuEnabled} />
        </>
      )}
    </AppHeaderContainer>
  );
};

export const MobileHeader: React.FC = () => {
  const HeaderComponent = useMobileHeaderComponent();

  return HeaderComponent ? <HeaderComponent /> : <StandardMobileHeader />;
};
